import actions from "./actions";

const riskAssessmentTemplateModule = {
  state: {},
  mutations: {},
  actions,
  getters: {},
};

export default riskAssessmentTemplateModule;
